import type { Settings } from '@/features/Broker/settingsSchema';

export interface Broker {
  email: string;
  id: number;
  hasActiveSmtpData: boolean;
  intercomUserHash: string | null;
}

export interface Rights {
  antrag: {
    erstellen: boolean;
    erstantrag: boolean;
  };
  print: {
    mail: boolean;
  };
  isAdmin: boolean;
  tarife: {
    logDownload: boolean;
  };
  profile: {
    showCreationWarning: boolean;
  };
}

export enum RATING_TYPE {
  ERFUELLUNGSGRAD = 'erfuellungsgrad',
  STARS = 'stars',
}

export interface SettingsStoreData<T = Settings> {
  data: T;
  isLoading: boolean;
}
